<template>
  <v-card>
    <v-toolbar
      class="px-4"
      style="
        background: linear-gradient(60deg, #66bb6a, #43a047);
        color: white;
      "
    >
      <span
        style="
          font-size: 1.125rem;
          line-height: 1.4em;
          font-weight: 300;
          font-size: 18px;
        "
        >{{
          $t('commonWords.create') +
          ' ' +
          $t('commonWords.newF') +
          ' ' +
          $t('commonWords.entity')
        }}</span
      >
      <v-spacer></v-spacer>
      <md-button
        @click="$emit('close-create-dialog')"
        class="md-simple md-just-icon"
      >
        <md-icon>close</md-icon>
      </md-button>
    </v-toolbar>
    <v-card-text class="pa-0">
      <md-card-content>
        <div class="md-layout">
          <div class="textLabel colorDark" style="margin-top: 12px;">
            {{ $t('entityCreate.name') }}
          </div>
          <div class="textLabel colorGrey">
            {{ $t('entityCreate.textName') }}
          </div>
          <md-field style="margin-top: 0;">
            <md-icon>alternate_email</md-icon>
            <md-input
              v-model="entity.entity"
              :placeholder="$t('entityCreate.nameLabel')"
            ></md-input>
          </md-field>
          <div class="md-layout" style="margin-top: 8px; margin-bottom: 10px;">
            <div class="md-layout-item" style="margin: auto;">
              Fuzzy matching
            </div>
            <div
              class="md-layout-item md-form-label md-size-15"
              style="padding: 0; margin: auto;"
              :class="{
                'text-success': entity.fuzzy_match,
                'text-danger': !entity.fuzzy_match,
              }"
            >
              {{
                entity.fuzzy_match
                  ? $t('commonWords.enabled')
                  : $t('commonWords.disabled')
              }}
            </div>
            <div class="md-layout-item md-size-15">
              <md-switch v-model="entity.fuzzy_match"></md-switch>
            </div>
          </div>
          <div style="width: 100%;">
            <div
              class="md-layout"
              style="width: 100%; justify-content: flex-end;"
            >
              <md-button @click="saveNewEntity()" class="md-success">
                <span>{{ $t('commonWords.create') }}</span>
              </md-button>
            </div>
          </div>
        </div>
      </md-card-content>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      entity: {}
    }
  },
  methods: {
    saveNewEntity () {
      this.$emit('save', this.entity)
      this.$emit('close-create-dialog')
      this.clear()
    },
    clear () {
      this.entity = {
        entity: '',
        fuzzy_match: true,
        values: []
      }
    }
  },
  created () {
    this.clear()
  }
}
</script>

<style scoped>
.md-button.md-simple i {
  color: white !important;
}
.textLabel {
  width: 100%;
  font-size: 14px;
  line-height: 24px;
}
.colorDark {
  color: #393939;
}
.colorGrey {
  color: rgba(111, 111, 111, 0.603);
}
</style>
